/** Class that provides DOM utility functions. */
class DomHelpers {
  /**
   * Walks up the DOM hierarchy returning the first DOM node that matches
   * the class name.
   *
   * TODO (dev@hugeinc.com) Needs fix for IE11 elements which do not support
   * classList.
   *
   * @param {Node} el The DOM node to start with.
   * @param {string} className The class name that is being searched for.
   * @return {?Node} The DOM node that matches the class name or null.
   */
  getAncestorByClassName (el, className) {
    while (el && el.classList) {
      if (this.hasClass(el, className)) {
        return el
      }

      el = el.parentNode
    }

    // Reached the root of the DOM without a match
    return null
  }

  /**
   * Retrieves the current Y scroll position of the page.
   * @return {number} The vertical page offset in pixels.
   */
  getPageYOffset () {
    return window.pageYOffset || document.documentElement.scrollTop
  }

  /**
   * Retrieves the height of the window.
   * @return {number} The height of the window in pixels.
   */
  getWindowHeight () {
    return window.innerHeight || document.documentElement.clientHeight ||
        document.getElementsByTagName('body')[0].clientHeight
  }

  /**
   * Retrieves the width of the window.
   * @return {number} The width of the window in pixels.
   */
  getWindowWidth () {
    return window.innerWidth || document.documentElement.clientWidth ||
        document.getElementsByTagName('body')[0].clientWidth
  }

  /**
   * Checks if an element has a css class.
   * @param {Object} el The DOM node to test.
   * @param {string} className The css class name to test for.
   * @return {boolean} Whether the element has the css class.
   */
  hasClass (el, className) {
    return el.classList.contains(className)
  }
}

export default new DomHelpers()



// WEBPACK FOOTER //
// ./src/assets/js/dom.js